enum LanguagesEndpoints {
  Languages = '/labels-i18n/v1/signup',
}

export default LanguagesEndpoints;
